var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 4,
    viewBox: "0 0 6 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.85896 0.965266L3.48391 3.76373C3.3546 3.91519 3.1809 4 3 4C2.8191 4 2.6454 3.91519 2.51609 3.76373L0.141037 0.965266C0.0742926 0.886902 0.0285641 0.786502 0.00968859 0.676882C-0.00918695 0.567262 -0.000353418 0.453395 0.0350618 0.349812C0.0704771 0.24623 0.130868 0.157632 0.208525 0.0953264C0.286183 0.0330207 0.377586 -0.000166491 0.471067 6.28072e-07H5.52893C5.62241 -0.000166491 5.71382 0.0330207 5.79147 0.0953264C5.86913 0.157632 5.92952 0.24623 5.96494 0.349812C6.00035 0.453395 6.00919 0.567262 5.99031 0.676882C5.97144 0.786502 5.92571 0.886902 5.85896 0.965266Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.e7fd079d64a1063b7c8dfcd57adcaad7.svg";
export { ForwardRef as ReactComponent };